import classNames from "classnames";
import { When } from "react-if";
import styles from "./index.module.less";

const COLS = ["left", "right"];

export default function Shortcut({ data }) {
  return (
    <div className={styles.container}>
      {COLS.map((col) => (
        <div className={styles.col} key={col}>
          {data[col].map((group, index) => (
            <div className={styles.group} key={index}>
              <When condition={group.title}>
                <div className={styles.title}>{group.title}</div>
              </When>
              <div className={styles.list}>
                {group.list.map((item, index) => (
                  <div
                    className={classNames([
                      styles.item,
                      index % 2 ? null : styles.color,
                    ])}
                    key={item.key}
                  >
                    <div className={styles.content}>
                      <div
                        className={classNames([
                          styles.text,
                          { [styles.new]: item.new },
                        ])}
                      >
                        {item.label}
                      </div>
                      <div className={styles.keyGroup}>
                        {Array.isArray(item.display) ? (
                          item.type === "or" ? (
                            item.display.reduce((result, item, index) => {
                              if (index !== 0) {
                                result.push(
                                  <div
                                    className={styles.split}
                                    key={`${item}-split`}
                                  >
                                    或
                                  </div>
                                );
                              }
                              result.push(
                                <div className={styles.key} key={item}>
                                  {item}
                                </div>
                              );
                              return result;
                            }, [])
                          ) : (
                            item.display.reduce((result, item, index) => {
                              if (index !== 0) {
                                result.push(
                                  <div
                                    className={styles.split}
                                    key={`${item}-split`}
                                  >
                                    +
                                  </div>
                                );
                              }
                              result.push(
                                <div className={styles.key} key={item}>
                                  {item}
                                </div>
                              );
                              return result;
                            }, [])
                          )
                        ) : (
                          <div className={styles.key}>{item.display}</div>
                        )}
                      </div>
                    </div>
                    <When condition={item?.sublabel}>
                      <div className={styles.subcontent}>
                        {item?.sublabel?.map((text) => (
                          <div key={text}>{text}</div>
                        ))}
                      </div>
                    </When>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
